import { Component, OnInit } from '@angular/core';
import { CommonsService } from 'src/app/services/commons/commons.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  versione: string = '2.0.0'; // valore di default

  constructor(private commonsService: CommonsService) { }

  ngOnInit(): void {
    this.caricaVersione();
  }

  caricaVersione(): void {
    this.commonsService.getVersione().subscribe({
      next: (response) => {
        this.versione = response.result.descrizione;
      },
      error: (error) => {
        console.error('Errore nel caricamento della versione:', error);
      }
    });
  }
}
